import { Inject, Injectable } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BehaviorSubject, delay, finalize, Observable, of, tap } from 'rxjs';
import { ENVIRONMENT_TOKEN } from '../../../injection.tokens';
import { IEnvironment } from '../../../_environment/interface';
import { OrderDataProvider } from '../../../data-provider/order.data-provider';
import { OrderHelper } from '../../../helper/order.helper';
import { OrderItemType, PreOrderService } from '../../../service/pre-order.service';
import { GadgetViewModel } from '../../../model/view-model/gadget/gadget.view.model';
import { GadgetItemViewModel } from '../../../model/view-model/order/gadget-item/gadget-item.view.model';

@Injectable({
  providedIn: 'root'
})
export class ECommerceService extends PreOrderService {
  private productsSubject = new BehaviorSubject<GadgetViewModel[]>([]);
  public products$: Observable<GadgetViewModel[]> = this.productsSubject.asObservable();

  private isLoadingSubject = new BehaviorSubject<boolean>(false);
  public isLoading$: Observable<boolean> = this.isLoadingSubject.asObservable();

  private errorSubject = new BehaviorSubject<string | null>(null);
  public error$: Observable<string | null> = this.errorSubject.asObservable();

  gadgets: GadgetViewModel[] = [];

  constructor(
    @Inject(ENVIRONMENT_TOKEN) protected environment: IEnvironment,
    protected orderDataProvider: OrderDataProvider,
    protected modalService: BsModalService,
    protected orderHelper: OrderHelper
  ) {
    super(OrderItemType.GADGET_ITEMS, orderDataProvider, orderHelper, modalService);
  }

  public cleanPreOrder() {
    this.preOrder.items = [];
  }

  fetchProducts(orderGadgetItems: GadgetItemViewModel[], cinemaId: string, cardId?: string, movieId?: string, screeningId?: string): void {
    if (!cinemaId) {
      return;
    }

    this.isLoadingSubject.next(true);
    this.errorSubject.next(null);

    this.orderDataProvider
      .getGadgets(cinemaId, {
        cardId,
        movieId,
        screeningId
      })
      .pipe(
        tap((gadgets: GadgetViewModel[]) => {
          this.gadgets = gadgets;
          this.restoreQuantitiesFromOrder(orderGadgetItems);
        }),
        finalize(() => {
          this.isLoadingSubject.next(false);
        })
      )
      .subscribe();
  }

  restoreQuantitiesFromOrder(orderGadgetItems: GadgetItemViewModel[] = []) {
    const updatedGadgets = this.gadgets.map((gadget) => {
      const orderItem = orderGadgetItems?.find((ogi) => ogi.itemId === gadget.itemId);
      if (orderItem) {
        gadget.quantity = orderItem.quantity;
      }
      return gadget;
    });

    this.productsSubject.next(updatedGadgets);
  }
}
